export enum ModalTheme {
    Default,
    LightBlue
}
